import {
  GET_SURVEY_SCHEDULERS,
  FETCH_SURVEY_SCHEDULER,
  ADD_SURVEY_SCHEDULER,
  UPDATE_SURVEY_SCHEDULER,
  DELETE_SURVEY_SCHEDULER,
  CLEAR_SURVEY_SCHEDULERS,
  SURVEY_SCHEDULERS_PAGE,
  CLEAR_ALL,
  SURVEY_SCHEDULERS_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  survey_schedulers: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function surveySchedulers(state = initialState, action) {
  switch (action.type) {
    case SURVEY_SCHEDULERS_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_SURVEY_SCHEDULERS:
      return {
        ...state,
        survey_schedulers: action.payload,
        pending: false,
      };
    case SURVEY_SCHEDULERS_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_SURVEY_SCHEDULER:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_SURVEY_SCHEDULER:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_SURVEY_SCHEDULER:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_SURVEY_SCHEDULER:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_SURVEY_SCHEDULERS:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}